/* /posts and /posts/<id> — the community feed in the browser.
 * The server rendered the first page (pages/posts.php + inc/ktm-posts.php, whose markup the renderers
 * below mirror) and embedded #feed-data. Here: more pages and tabs from /posts-feed.php, "N new posts",
 * the composer (@handles from displayNames, [[card names]] from Scryfall, #tags, one of your decks),
 * likes (togglePostLike), replies, follows, views, sharing, deleting your own posts and replies, card
 * previews. Reads that need no account go straight to Firestore REST (likes, follows, handles); the
 * Firebase SDK loads only for signed-in people, when they first need it.
 */
import "../lib/site.js";
import "../lib/cards.js";
import "../lib/cardsheet.js";
import "../lib/fb-lazy.js";

(function () {
  "use strict";

  var KD = window.KD, esc = KD.esc;
  var dataEl = document.getElementById("feed-data");
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (data.missing) return;
  var FN = "https://us-central1-krakenthemeta.cloudfunctions.net/";
  var DB = "projects/krakenthemeta/databases/(default)/documents";
  var FS = "https://firestore.googleapis.com/v1/" + DB;
  var MAX = 500;
  var users = data.users || {}, handles = data.handles || {};
  var isPostPage = !!data.post;
  var me = null; // {uid, name, avatar, handle} once the SDK says who is signed in
  var addReplyRef = null, deleteReplyRef = null; // set on a post's own page
  function addReply(r) { if (addReplyRef) addReplyRef(r); }
  function deleteReply(cid, el) { if (deleteReplyRef) deleteReplyRef(cid, el); }
  // posts you just wrote (this tab, last 2 minutes): shown at once, before the server's 30-second cache has them
  var mine = [];
  try { mine = JSON.parse(sessionStorage.getItem("kd_my_posts") || "[]"); } catch (e) { mine = []; }
  if (!Array.isArray(mine)) mine = [];
  function fresh() { return mine.filter(function (p) { return Date.now() - p.t < 120000; }); }
  function rememberMine(p) { mine = [p].concat(fresh()).slice(0, 5); try { sessionStorage.setItem("kd_my_posts", JSON.stringify(mine)); } catch (e) { /* ignore */ } }
  function forgetMine(id) { mine = mine.filter(function (p) { return p.i !== id; }); try { sessionStorage.setItem("kd_my_posts", JSON.stringify(mine)); } catch (e) { /* ignore */ } }

  // ================================================================ renderers (same markup as inc/ktm-posts.php)
  function icon(id, cls) { return KD.icon(id, cls); }
  var FORMAT = { commander: "Commander", standard: "Standard", modern: "Modern", pioneer: "Pioneer", legacy: "Legacy", vintage: "Vintage", pauper: "Pauper", historic: "Historic", alchemy: "Alchemy", brawl: "Brawl", explorer: "Explorer", timeless: "Timeless", standardbrawl: "Standard Brawl" };
  function fmtLabel(f) { f = String(f || "").toLowerCase(); return FORMAT[f] || (f ? f.charAt(0).toUpperCase() + f.slice(1) : "Casual"); }

  var RICH = /(https?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]])|\[\[([^\[\]\n]{1,60})\]\]|(^|[^\w\/@])@([A-Za-z0-9_-]{1,15})|(^|[^\w\/#&])#([A-Za-z][A-Za-z0-9_]{1,29})/g;
  function plain(s) { return esc(s).replace(/\n/g, "<br>\n"); }
  function rich(text) {
    var out = "", pos = 0, m;
    text = String(text || "");
    RICH.lastIndex = 0;
    while ((m = RICH.exec(text))) {
      out += plain(text.slice(pos, m.index));
      if (m[1]) {
        var show = m[1].replace(/^https?:\/\/(www\.)?/, "");
        if (show.length > 34) show = show.slice(0, 32) + "…";
        out += '<a class="plink" href="' + esc(m[1]) + '" target="_blank" rel="nofollow ugc noopener">' + esc(show) + "</a>";
      } else if (m[2]) {
        var name = m[2].trim();
        out += '<a class="cardref" href="/cards-pricing?q=' + encodeURIComponent('!"' + name + '"') + '" data-card="' + esc(name) + '">' + esc(name) + "</a>";
      } else if (m[4]) {
        out += plain(m[3]) + '<a class="mention" href="' + (handles[m[4]] ? "/profile.php?userId=" + encodeURIComponent(handles[m[4]]) : "/all-users") + '" data-handle="' + esc(m[4]) + '">@' + esc(m[4]) + "</a>";
      } else {
        out += plain(m[5]) + '<a class="hashtag" href="/posts?tag=' + encodeURIComponent(m[6].toLowerCase()) + '">#' + esc(m[6]) + "</a>";
      }
      pos = m.index + m[0].length;
    }
    return out + plain(text.slice(pos));
  }
  function ago(ms) {
    var d = Math.floor((Date.now() - ms) / 1000);
    if (d < 60) return "now";
    if (d < 3600) return Math.floor(d / 60) + "m";
    if (d < 86400) return Math.floor(d / 3600) + "h";
    if (d < 7 * 86400) return Math.floor(d / 86400) + "d";
    var dt = new Date(ms), now = new Date();
    return dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: dt.getFullYear() !== now.getFullYear() ? "numeric" : undefined });
  }
  function who(p) {
    var u = users[p.u] || { n: "", a: "/assets/img/avatars/avatar1.webp" };
    return { name: u.n || (p.a && p.a.p) || "Brewer", avatar: KD.safeUrl(u.a) || "/assets/img/avatars/avatar1.webp", handle: u.h || "", off: !!u.off };
  }
  function iso(ms) { return new Date(ms).toISOString().replace(/\.\d{3}Z$/, "+00:00"); }
  function headHTML(p, w, label) {
    return '<header class="post__head"><a class="post__name" href="/profile.php?userId=' + encodeURIComponent(p.u) + '">' + esc(w.name) + "</a>" +
      (w.off ? '<span class="post__badge" title="KrakenTheMeta">' + icon("verified") + "</span>" : "") +
      (w.handle && w.handle !== w.name ? '<span class="post__handle">@' + esc(w.handle) + "</span>" : "") +
      (label ? '<span class="post__label">' + label + "</span>" : "") +
      '<span class="post__dot" aria-hidden="true">·</span><a class="post__time" href="/posts/' + encodeURIComponent(p.i) + '"><time datetime="' + iso(p.t) + '" title="' + esc(new Date(p.t).toLocaleString()) + '">' + ago(p.t) + "</time></a>" +
      '<button class="post__more" type="button" data-more aria-label="More options">' + icon("dots") + "</button></header>";
  }
  function deckHTML(d) {
    var art = KD.safeUrl(d.art);
    return '<a class="pdeck" href="/deck-view?deckId=' + encodeURIComponent(d.id) + '"><span class="pdeck__art"' + (art ? ' style="background-image:url(&quot;' + esc(art) + '&quot;)"' : "") + "></span>" +
      '<span class="pdeck__body"><span class="pdeck__tag">' + icon("layers") + esc(fmtLabel(d.f)) + " deck</span><b>" + esc(d.n) + "</b>" + (d.c ? "<small>" + esc(d.c) + "</small>" : "") +
      '</span><span class="pdeck__go">View deck ' + icon("arrow") + "</span></a>";
  }
  var RES = { win: "Win", loss: "Loss", draw: "Draw" };
  function recapUrl(a) { return "/match-recap?u=" + encodeURIComponent(a.au) + "&amp;m=" + encodeURIComponent(a.mid); }
  function arenaHTML(p) {
    var a = p.a, bits = [];
    if (a.f) bits.push(esc(fmtLabel(a.f)));
    if (a.tu) bits.push(a.tu + (a.tu === 1 ? " turn" : " turns"));
    if (a.yl != null && a.ol != null) bits.push("life " + a.yl + "–" + a.ol);
    return '<div class="arena"><span class="arena__res is-' + esc(a.r) + '">' + (RES[a.r] || "Draw") + "</span>" +
      '<div class="arena__body"><b>' + esc(a.dn || "Arena deck") + "</b><span>" + bits.join(" · ") + "</span></div>" +
      (a.mid ? '<a class="arena__go" href="' + recapUrl(a) + '">' + icon("play") + "<span>Replay</span></a>" : "") + "</div>";
  }
  function actionsHTML(p) {
    return '<footer class="post__acts">' +
      '<a class="pact pact--reply" href="/posts/' + encodeURIComponent(p.i) + '#reply" data-reply aria-label="Reply (' + p.c + ')">' + icon("chat") + "<span>" + (p.c || "") + "</span></a>" +
      '<button class="pact pact--like" type="button" data-like aria-pressed="false" aria-label="Like (' + p.l + ')">' + icon("heart") + "<span data-likes>" + (p.l || "") + "</span></button>" +
      '<span class="pact pact--views" title="Views">' + icon("eye") + "<span data-views>" + (p.v || "") + "</span></span>" +
      '<button class="pact pact--share" type="button" data-share aria-label="Share">' + icon("share") + "</button></footer>";
  }
  function postHTML(p, full) {
    var w = who(p), arena = p.ty === "arena" && p.a;
    var body = arena ? "" : '<div class="post__text">' + rich(p.m) + "</div>";
    if (p.d) body += deckHTML(p.d);
    if (p.img && KD.safeUrl(p.img)) body += '<a class="post__img" href="/posts/' + encodeURIComponent(p.i) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy" decoding="async" onerror="this.parentNode.remove()"></a>';
    if (arena) body += arenaHTML(p);
    return '<article class="post' + (arena ? " post--arena" : "") + (full ? " post--full" : "") + '" data-id="' + esc(p.i) + '" data-uid="' + esc(p.u) + '" data-t="' + p.t + '">' +
      '<a class="post__av" href="/profile.php?userId=' + encodeURIComponent(p.u) + '" tabindex="-1" aria-hidden="true"><img class="avatar" src="' + esc(w.avatar) + '" alt="" width="44" height="44" loading="lazy" decoding="async"></a>' +
      '<div class="post__main">' + headHTML(p, w, arena ? "played on MTG Arena" : "") + body + actionsHTML(p) + "</div></article>";
  }
  function groupHTML(rows) {
    var first = rows[0], w = who(first);
    var wins = rows.filter(function (p) { return p.a.r === "win"; }).length;
    var label = "went <b>" + wins + "–" + (rows.length - wins) + "</b> on Arena";
    var list = rows.slice(0, 5).map(function (p) {
      var a = p.a;
      return '<li class="agame" data-id="' + esc(p.i) + '"><span class="arena__res is-' + esc(a.r) + '">' + a.r.charAt(0).toUpperCase() + "</span>" +
        '<a class="agame__deck" href="/posts/' + encodeURIComponent(p.i) + '">' + esc(a.dn || "Arena deck") + "</a>" +
        '<span class="agame__meta">' + (a.tu ? a.tu + (a.tu === 1 ? " turn" : " turns") : "") + "</span>" +
        (a.mid ? '<a class="arena__go arena__go--sm" href="' + recapUrl(a) + '" aria-label="Replay">' + icon("play") + "</a>" : "") + "</li>";
    }).join("");
    var more = rows.length > 5 ? '<a class="agroup__more" href="/posts?tab=arena&amp;author=' + encodeURIComponent(first.u) + '">+' + (rows.length - 5) + " more games</a>" : "";
    return '<article class="post post--group" data-id="' + esc(first.i) + '" data-uid="' + esc(first.u) + '" data-t="' + first.t + '">' +
      '<a class="post__av" href="/profile.php?userId=' + encodeURIComponent(first.u) + '" tabindex="-1" aria-hidden="true"><img class="avatar" src="' + esc(w.avatar) + '" alt="" width="44" height="44" loading="lazy" decoding="async"></a>' +
      '<div class="post__main">' + headHTML(first, w, label) + '<ul class="agroup">' + list + "</ul>" + more + "</div></article>";
  }
  function replyHTML(r) {
    var u = users[r.u] || { n: "", a: "/assets/img/avatars/avatar1.webp" };
    return '<article class="reply" data-cid="' + esc(r.i) + '" data-uid="' + esc(r.u) + '">' +
      '<a class="post__av" href="/profile.php?userId=' + encodeURIComponent(r.u) + '" tabindex="-1" aria-hidden="true"><img class="avatar" src="' + esc(KD.safeUrl(u.a) || "/assets/img/avatars/avatar1.webp") + '" alt="" width="36" height="36" loading="lazy" decoding="async"></a>' +
      '<div class="post__main"><header class="post__head"><a class="post__name" href="/profile.php?userId=' + encodeURIComponent(r.u) + '">' + esc(u.n || "Brewer") + "</a>" +
      (u.off ? '<span class="post__badge" title="KrakenTheMeta">' + icon("verified") + "</span>" : "") +
      '<span class="post__dot" aria-hidden="true">·</span><time class="post__time" datetime="' + iso(r.t) + '">' + ago(r.t) + "</time>" +
      '<button class="post__more" type="button" data-reply-more aria-label="More options">' + icon("dots") + "</button></header>" +
      '<div class="post__text">' + rich(r.m) + "</div></div></article>";
  }
  // consecutive Arena results by one player within 6 hours fold into one card (as the server does)
  function group(rows) {
    var out = [];
    rows.forEach(function (p) {
      var last = out[out.length - 1];
      if (p.ty === "arena" && last) {
        var prev = last.g ? last.g[last.g.length - 1] : last;
        if (prev.ty === "arena" && prev.u === p.u && prev.t - p.t < 6 * 3600 * 1000) {
          if (!last.g) out[out.length - 1] = last = { g: [last] };
          last.g.push(p);
          return;
        }
      }
      out.push(p);
    });
    return out;
  }
  function itemsHTML(rows, grouped) {
    return (grouped ? group(rows) : rows).map(function (it) { return it.g ? (it.g.length > 1 ? groupHTML(it.g) : postHTML(it.g[0])) : postHTML(it); }).join("");
  }
  function merge(res) {
    Object.keys(res.users || {}).forEach(function (k) { users[k] = res.users[k]; });
    Object.keys(res.handles || {}).forEach(function (k) { handles[k] = res.handles[k]; });
  }

  // ================================================================ REST helpers (no SDK, no account)
  function batchGet(paths) {
    if (!paths.length) return Promise.resolve({});
    return fetch(FS + ":batchGet", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ documents: paths.map(function (p) { return DB + "/" + p; }) }) })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (rows) {
        var out = {};
        (rows || []).forEach(function (r) {
          if (r.found) out[r.found.name.slice(DB.length + 1)] = r.found;
          else if (r.missing) out[r.missing.slice(DB.length + 1)] = null;
        });
        return out;
      }).catch(function () { return {}; });
  }
  function feedUrl(params) {
    var q = new URLSearchParams();
    Object.keys(params).forEach(function (k) { if (params[k] !== "" && params[k] != null) q.set(k, params[k]); });
    return "/posts-feed.php?" + q.toString();
  }
  function getJSON(url) { return fetch(url, { headers: { Accept: "application/json" } }).then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); }); }

  // ================================================================ signed-in bootstrap (lazy SDK)
  var authP = null;
  function auth(extra) {
    if (!KD.signedIn) return Promise.resolve(null);
    if (!authP) {
      authP = KD.firebase.load(["functions"]).then(KD.firebase.user).then(function (u) {
        if (!u) { KD.signedIn = false; document.documentElement.classList.remove("is-user"); return null; }
        me = { uid: u.uid, name: u.displayName || "Brewer", avatar: "/assets/img/avatars/avatar1.webp", handle: "" };
        return firebase.firestore().collection("users").doc(u.uid).get().then(function (d) {
          var x = d.exists ? d.data() || {} : {};
          me.name = (x.name || me.name).slice(0, 40);
          me.avatar = KD.avatar ? KD.avatar(x.profileImage || x.avatar || "") : (x.profileImage || me.avatar);
          if (/^[A-Za-z0-9_-]{1,15}$/.test(x.name || "")) me.handle = x.name;
          users[me.uid] = { n: me.name, a: me.avatar, h: me.handle || undefined, off: me.uid === "bM0VAzCsnlXaNSZK6wp5wgud5pE3" ? 1 : undefined };
          KD.$$("[data-me-avatar]").forEach(function (img) { img.src = me.avatar; });
          return me;
        }).catch(function () { return me; });
      });
      authP.catch(function () { authP = null; });
    }
    return extra ? authP.then(function (m) { return m ? KD.firebase.load(extra).then(function () { return m; }) : m; }) : authP;
  }
  function askSignIn(what) {
    var s = KD.sheet({
      title: "Sign in to " + what,
      body: '<p class="hint" style="font-size:15px">A free KrakenTheMeta account lets you post, reply, like and follow other brewers, and build decks with AI.</p>',
      foot: '<button class="btn btn--ghost" type="button" data-close>Not now</button><a class="btn btn--lure" href="https://krakenthemeta.com/sign-in" data-signin>Sign in or create an account</a>'
    });
    var a = KD.$("[data-signin]", s.el);
    if (a) a.addEventListener("click", rememberReturn);
  }
  function rememberReturn() { try { localStorage.setItem("kraken_return_to", location.pathname.replace(/[^A-Za-z0-9/_-]/g, "") || "/posts"); } catch (e) { /* ignore */ } }
  KD.$$("[data-signin]").forEach(function (a) { a.addEventListener("click", rememberReturn); });
  function notify(uid, message) {
    if (!me || !uid || uid === me.uid) return;
    KD.firebase.load(["database"]).then(function () {
      return firebase.database().ref("notifications").child(uid).push({ message: message, taggerId: me.uid, taggerName: me.name, timestamp: Date.now(), viewed: false });
    }).catch(function () { /* the bell just misses this one */ });
  }

  // ================================================================ likes + follows state
  var liked = {}; // postId → liked by me, once known (re-rendered posts are painted from it)
  function hydrateLikes() {
    if (!me) return;
    var ids = [];
    KD.$$("article.post:not(.post--group)[data-id]").forEach(function (a) {
      var id = a.getAttribute("data-id");
      if (Object.prototype.hasOwnProperty.call(liked, id)) { if (liked[id]) paintLike(id, true); } else if (ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) return;
    ids.forEach(function (id) { liked[id] = false; });
    batchGet(ids.map(function (id) { return "posts/" + id + "/likes/" + me.uid; })).then(function (found) {
      ids.forEach(function (id) { if (found["posts/" + id + "/likes/" + me.uid]) paintLike(id, true); });
    });
  }
  function paintLike(id, on, count) {
    liked[id] = on;
    KD.$$('article.post[data-id="' + id + '"] [data-like]').forEach(function (b) {
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", String(on));
      if (count != null) KD.$("[data-likes]", b).textContent = count || "";
    });
    if (count != null && isPostPage && data.post.i === id) stat("[data-likes]", count, "like", "likes");
  }
  // the stats line under a post on its own page: "<b>n</b> word"
  function stat(sel, n, one, many) {
    var b = KD.$(".postmeta " + sel);
    if (!b) return;
    b.textContent = KD.fmt(n);
    if (b.nextSibling) b.nextSibling.textContent = " " + (n === 1 ? one : many);
  }
  function hydrateFollows() {
    if (!me) return;
    var btns = KD.$$("[data-follow]").filter(function (b) { return !b._checked; });
    btns.forEach(function (b) { b._checked = true; if (b.getAttribute("data-follow") === me.uid) b.remove(); });
    btns = btns.filter(function (b) { return b.isConnected; });
    if (!btns.length) return;
    batchGet(btns.map(function (b) { return "users/" + me.uid + "/following/" + b.getAttribute("data-follow"); })).then(function (found) {
      btns.forEach(function (b) { paintFollow(b, !!found["users/" + me.uid + "/following/" + b.getAttribute("data-follow")]); b.hidden = false; });
    });
  }
  function paintFollow(b, on) { b.classList.toggle("is-on", on); b.textContent = on ? "Following" : "Follow"; b.classList.toggle("btn--lure", !on && b.closest(".fauthor") !== null); }

  if (KD.signedIn) {
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 900); })(function () {
      auth().then(function (m) { if (m) { hydrateLikes(); hydrateFollows(); } }).catch(function () { /* stays read-only */ });
    });
  } else {
    KD.$$("[data-follow]").forEach(function (b) { b.hidden = false; });
  }

  // ================================================================ the feed (tabs, paging, new posts)
  var feedEl = KD.$("[data-feed]"), moreEl = KD.$("[data-feedmore]");
  // gen goes up with every tab load: a page or count that arrives after the tab changed is dropped
  var st = { tab: data.tab || "all", tag: data.tag || "", author: data.author || "", next: data.next || null, newest: data.newest || 0, loading: false, gen: 0 };
  function grouped() { return st.tab === "all" && !st.tag && !st.author; }
  function params(extra) { return Object.assign({ tab: st.tab === "all" ? "" : st.tab, tag: st.tag, author: st.author, uid: st.tab === "following" && me ? me.uid : "" }, extra || {}); }
  function paintMore() {
    if (!moreEl) return;
    moreEl.innerHTML = st.next ? '<a class="btn btn--ghost" href="' + esc(pageUrl()) + '" data-loadmore>Show older posts</a>' : (feedEl && KD.$("article", feedEl) ? '<p class="hint">You\'re all caught up.</p>' : "");
  }
  function pageUrl() {
    var q = new URLSearchParams();
    if (st.tab !== "all") q.set("tab", st.tab);
    if (st.tag) q.set("tag", st.tag);
    if (st.author) q.set("author", st.author);
    var s = q.toString();
    return "/posts" + (s ? "?" + s : "");
  }
  function loadMore() {
    if (st.loading || !st.next) return;
    var gen = st.gen;
    st.loading = true;
    feedEl.setAttribute("aria-busy", "true");
    getJSON(feedUrl(params({ before: st.next }))).then(function (res) {
      if (gen !== st.gen) return;
      merge(res);
      var fresh = (res.posts || []).filter(function (p) { return !KD.$('article[data-id="' + p.i + '"]', feedEl); });
      feedEl.insertAdjacentHTML("beforeend", itemsHTML(fresh, grouped()));
      st.next = res.next;
      paintMore();
      hydrateLikes();
    }).catch(function () { if (gen === st.gen) KD.toast("Couldn't load more posts. Try again.", "err"); })
      .then(function () { st.loading = false; if (gen === st.gen) feedEl.setAttribute("aria-busy", "false"); });
  }
  // straight to the top, even though the site scrolls smoothly (html { scroll-behavior: smooth })
  function jumpTop() {
    if (window.scrollY <= 0) return;
    var h = document.documentElement.style, prev = h.scrollBehavior;
    h.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    h.scrollBehavior = prev;
  }
  function loadTab(push) {
    if (!feedEl) return;
    if (st.tab === "following" && !me) {
      if (!KD.signedIn) {
        // only reachable from a shared ?tab=following link: the tab itself is hidden when signed out
        feedEl.innerHTML = '<div class="empty feedempty">' + icon("user") + "<h3>Sign in to see who you follow</h3><p>Posts and Arena games from the brewers you follow show up here.</p>" +
          '<a class="btn btn--lure" href="https://krakenthemeta.com/sign-in" data-signin>Sign in</a></div>';
        KD.$$("[data-signin]", feedEl).forEach(function (a) { a.addEventListener("click", rememberReturn); });
        if (moreEl) moreEl.innerHTML = "";
        return;
      }
      feedEl.innerHTML = '<div class="feedskel"><span></span><span></span><span></span></div>';
      auth().then(function (m) { if (m) loadTab(false); else feedEl.innerHTML = followEmpty(); });
      return;
    }
    KD.$$("[data-tab]").forEach(function (t) { t.setAttribute("aria-selected", String(t.getAttribute("data-tab") === st.tab)); });
    if (push) try { history.pushState({ feed: 1 }, "", pageUrl()); } catch (e) { /* ignore */ }
    var title = KD.$(".feedbar__title h1");
    if (title) title.textContent = st.tag ? "#" + st.tag : "Community";
    var gen = ++st.gen;
    st.next = null; // the old tab's cursor must never page the new one
    if (moreEl) moreEl.innerHTML = "";
    feedEl.setAttribute("aria-busy", "true");
    feedEl.classList.add("is-loading");
    getJSON(feedUrl(params())).then(function (res) {
      if (gen !== st.gen) return;
      merge(res);
      var posts = res.posts || [];
      feedEl.innerHTML = posts.length ? itemsHTML(posts, grouped()) : (st.tab === "following" ? followEmpty(res.following) : emptyHTML());
      echoMine();
      st.next = res.next;
      st.newest = posts.length ? posts[0].t : Date.now();
      paintMore();
      hidePill();
      hydrateLikes();
      KD.ga("posts_tab", { tab: st.tab, tag: st.tag });
    }).catch(function () {
      if (gen !== st.gen) return;
      feedEl.innerHTML = '<div class="empty feedempty">' + icon("alert") + "<h3>Couldn't load the feed</h3><p>Check your connection and try again.</p></div>";
    }).then(function () { if (gen === st.gen) { feedEl.setAttribute("aria-busy", "false"); feedEl.classList.remove("is-loading"); } });
  }
  // A copy of the page older than 2 minutes came from a cache between the visitor and PHP: the
  // browser swaps in the current first page (the JSON endpoint is never page-cached).
  function stale() { return !!data.rendered && Date.now() - data.rendered > 120000; }
  function refreshFirst() {
    var gen = st.gen;
    getJSON(feedUrl(params())).then(function (res) {
      var posts = res.posts || [];
      if (!posts.length || st.loading || gen !== st.gen) return;
      merge(res);
      feedEl.innerHTML = itemsHTML(posts, grouped());
      echoMine();
      st.next = res.next;
      st.newest = posts[0].t;
      paintMore();
      hydrateLikes();
    }).catch(function () { /* the older copy stays */ });
  }
  function echoMine() {
    if (!feedEl || (st.tab !== "all" && st.tab !== "posts") || st.tag || st.author) return;
    var missing = fresh().filter(function (p) { return !KD.$('article[data-id="' + p.i + '"]', feedEl); });
    if (!missing.length) return;
    var empty = KD.$(".feedempty", feedEl);
    if (empty) empty.remove();
    missing.forEach(function (p) { if (p.me) users[p.u] = users[p.u] || p.me; });
    feedEl.insertAdjacentHTML("afterbegin", missing.map(function (p) { return postHTML(p); }).join(""));
  }
  function emptyHTML() {
    return '<div class="empty feedempty">' + icon("chat") + "<h3>" + (st.tag ? "Nothing tagged #" + esc(st.tag) + " yet" : "Nothing here yet") + "</h3><p>Be the first: share a brew or a question.</p></div>";
  }
  function followEmpty(n) {
    return '<div class="empty feedempty">' + icon("user") + "<h3>" + (n ? "Nothing new from the people you follow" : "Follow brewers to fill this tab") + "</h3><p>" +
      (n ? "Their posts and Arena games show up here." : "Follow people from their posts, the “Brewers to follow” list or their profiles.") + '</p><a class="btn btn--ghost" href="/posts">Back to For you</a></div>';
  }
  if (feedEl) {
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-tab]");
      if (t && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        st.tab = t.getAttribute("data-tab");
        jumpTop();
        loadTab(true);
        return;
      }
      var tag = e.target.closest("a.hashtag");
      if (tag && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        st.tag = decodeURIComponent((tag.getAttribute("href").split("tag=")[1] || "")).toLowerCase();
        st.author = "";
        if (st.tab === "following") st.tab = "all";
        loadTab(true);
        window.scrollTo({ top: 0, behavior: KD.reduce ? "auto" : "smooth" });
        return;
      }
      var lm = e.target.closest("[data-loadmore]");
      if (lm) { e.preventDefault(); loadMore(); }
    });
    window.addEventListener("popstate", function () {
      var q = new URLSearchParams(location.search);
      st.tab = ["posts", "arena", "following"].indexOf(q.get("tab")) !== -1 ? q.get("tab") : "all";
      st.tag = (q.get("tag") || "").toLowerCase().replace(/[^a-z0-9_]/g, "");
      st.author = (q.get("author") || "").replace(/[^A-Za-z0-9_-]/g, "");
      loadTab(false);
    });
    if ("IntersectionObserver" in window && moreEl) {
      new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) loadMore(); }, { rootMargin: "700px 0px" }).observe(moreEl);
    }
    if (st.tab === "following") loadTab(false);
    else if (stale()) refreshFirst();
    echoMine();
  }

  // "N new posts": checked every 45 seconds while the tab is visible
  var pill = KD.$("[data-newpill]"), newCount = 0;
  function hidePill() { if (pill) pill.hidden = true; newCount = 0; }
  function checkNew() {
    if (!feedEl || document.hidden || st.loading || st.tab === "following" && !me) return;
    var gen = st.gen;
    getJSON(feedUrl(params({ since: st.newest }))).then(function (res) {
      if (gen === st.gen && res.count > 0 && res.count !== newCount) {
        newCount = res.count;
        KD.$("[data-shownew]", pill).innerHTML = icon("arrow", "i--up") + "<span>Show " + res.count + " new " + (res.count === 1 ? "post" : "posts") + "</span>";
        pill.hidden = false;
      }
    }).catch(function () { /* try again next time */ });
  }
  if (pill) {
    setInterval(checkNew, 45000);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) checkNew(); });
    KD.$("[data-shownew]", pill).addEventListener("click", function () {
      loadTab(false);
      window.scrollTo({ top: 0, behavior: KD.reduce ? "auto" : "smooth" });
    });
  }

  // relative times stay fresh
  setInterval(function () { KD.$$("article time[datetime]").forEach(function (t) { var ms = Date.parse(t.getAttribute("datetime")); if (ms) t.textContent = ago(ms); }); }, 60000);

  // ================================================================ opening a post, sharing, menus
  document.addEventListener("click", function (e) {
    var art = e.target.closest("article.post:not(.post--full)");
    if (art && !e.target.closest("a, button, input, textarea, label, .agroup") && !(window.getSelection && String(window.getSelection()))) {
      var id = art.getAttribute("data-id");
      if (e.metaKey || e.ctrlKey) window.open("/posts/" + id, "_blank"); else location.href = "/posts/" + id;
    }
  });
  function postUrl(id) { return "https://krakenthemeta.com/posts/" + id; }
  function share(id) {
    KD.ga("posts_share", { post: id });
    if (navigator.share && KD.mobile()) { navigator.share({ title: "A post on KrakenTheMeta", url: postUrl(id) }).catch(function () {}); return; }
    KD.copy(postUrl(id), "Link copied.");
  }
  document.addEventListener("click", function (e) {
    var s = e.target.closest("[data-share]");
    if (s) { e.preventDefault(); share(s.closest("article").getAttribute("data-id")); return; }
    var more = e.target.closest("[data-more]");
    if (more) {
      e.preventDefault();
      var art = more.closest("article"), id = art.getAttribute("data-id"), uid = art.getAttribute("data-uid");
      var items = [
        { label: "Copy link", icon: "link", onClick: function () { KD.copy(postUrl(id), "Link copied."); } },
        { label: "Share on X", icon: "x-logo", href: "https://twitter.com/intent/tweet?url=" + encodeURIComponent(postUrl(id)), external: true },
        { label: "View profile", icon: "user", href: "/profile.php?userId=" + encodeURIComponent(uid) }
      ];
      if (me && me.uid === uid && !art.classList.contains("post--arena") && !art.classList.contains("post--group")) items.push("sep", { label: "Delete post", icon: "trash", danger: true, onClick: function () { deletePost(id, art); } });
      KD.menu(more, items, "Post");
      return;
    }
    var rm = e.target.closest("[data-reply-more]");
    if (rm) {
      e.preventDefault();
      var rep = rm.closest("article.reply"), cid = rep.getAttribute("data-cid"), ruid = rep.getAttribute("data-uid");
      var ritems = [{ label: "View profile", icon: "user", href: "/profile.php?userId=" + encodeURIComponent(ruid) }];
      if (me && me.uid === ruid) ritems.push("sep", { label: "Delete reply", icon: "trash", danger: true, onClick: function () { deleteReply(cid, rep); } });
      KD.menu(rm, ritems, "Reply");
    }
  });
  function deletePost(id, art) {
    KD.confirm({ title: "Delete this post?", body: "<p>It's removed from the feed for everyone. Replies go with it.</p>", confirm: "Delete", danger: true }).then(function (ok) {
      if (!ok) return;
      auth().then(function (m) {
        if (!m) return askSignIn("delete posts");
        return firebase.firestore().collection("posts").doc(id).delete().then(function () {
          KD.toast("Post deleted.", "ok");
          KD.ga("posts_delete");
          forgetMine(id);
          if (isPostPage) { location.href = "/posts"; return; }
          art.remove();
        });
      }).catch(function (err) { console.error("delete post", err); KD.toast("Couldn't delete that post. Try again.", "err"); });
    });
  }

  // likes
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-like]");
    if (!b) return;
    e.preventDefault();
    var art = b.closest("article"), id = art.getAttribute("data-id");
    if (!KD.signedIn) { askSignIn("like posts"); return; }
    if (b._busy) return;
    b._busy = true;
    var was = b.classList.contains("is-on"), n = parseInt(KD.$("[data-likes]", b).textContent, 10) || 0;
    paintLike(id, !was, Math.max(0, n + (was ? -1 : 1))); // optimistic
    auth(["functions"]).then(function (m) {
      if (!m) { paintLike(id, was, n); askSignIn("like posts"); return; }
      return firebase.functions().httpsCallable("togglePostLike")({ postId: id }).then(function (r) {
        var d = r.data || {};
        paintLike(id, !!d.liked, d.newLikeCount);
        KD.ga(d.liked ? "posts_like" : "posts_unlike");
        if (d.liked) notify(art.getAttribute("data-uid"), m.name + " liked your post");
      });
    }).catch(function (err) {
      console.error("like", err);
      paintLike(id, was, n);
      KD.toast("Couldn't save that like. Try again.", "err");
    }).then(function () { b._busy = false; });
  });

  // follows
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-follow]");
    if (!b) return;
    e.preventDefault();
    var uid = b.getAttribute("data-follow");
    if (!KD.signedIn) { askSignIn("follow brewers"); return; }
    if (b._busy) return;
    b._busy = true;
    auth().then(function (m) {
      if (!m) { askSignIn("follow brewers"); return; }
      var db = firebase.firestore(), on = b.classList.contains("is-on");
      var followerRef = db.collection("users").doc(uid).collection("followers").doc(m.uid);
      var followingRef = db.collection("users").doc(m.uid).collection("following").doc(uid);
      if (on) return Promise.all([followerRef.delete(), followingRef.delete()]).then(function () { KD.$$('[data-follow="' + uid + '"]').forEach(function (x) { paintFollow(x, false); }); KD.ga("posts_unfollow"); });
      var ts = firebase.firestore.FieldValue.serverTimestamp();
      return Promise.all([followerRef.set({ timestamp: ts }), followingRef.set({ timestamp: ts })]).then(function () {
        KD.$$('[data-follow="' + uid + '"]').forEach(function (x) { paintFollow(x, true); });
        notify(uid, m.name + " is now following you.");
        KD.ga("posts_follow");
      });
    }).catch(function (err) { console.error("follow", err); KD.toast("Couldn't update that follow. Try again.", "err"); })
      .then(function () { b._busy = false; });
  });

  // [[card]] references: the card sheet on click, the card image on hover
  document.addEventListener("click", function (e) {
    var c = e.target.closest("a.cardref, a.chip--card");
    if (!c || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    var name = c.getAttribute("data-card");
    KD.cardx.openLazy({ name: name }, { actions: '<a class="btn btn--ghost btn--sm" href="/cards-pricing?q=' + encodeURIComponent('!"' + name + '"') + '&prints=1">' + icon("search") + "<span>All printings &amp; prices</span></a>" });
    KD.ga("posts_card", { card: name });
  });
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)"), pop = null, peek = null;
  document.addEventListener("mouseover", function (e) {
    if (!fine.matches) return;
    var c = e.target.closest("a.cardref");
    if (!c || c === peek) return;
    peek = c;
    if (!pop) { pop = document.createElement("div"); pop.className = "cpop"; pop.setAttribute("aria-hidden", "true"); pop.innerHTML = '<img alt="">'; document.body.appendChild(pop); }
    pop.firstChild.src = "https://api.scryfall.com/cards/named?format=image&version=normal&exact=" + encodeURIComponent(c.getAttribute("data-card"));
    var r = c.getBoundingClientRect(), w = 220, h = Math.round(w * 680 / 488);
    var left = Math.min(window.innerWidth - w - 10, Math.max(10, r.left));
    var top = r.bottom + 8 + h > window.innerHeight ? r.top - h - 8 : r.bottom + 8;
    pop.style.left = left + "px";
    pop.style.top = Math.max(10, top) + "px";
    pop.classList.add("is-on");
  });
  document.addEventListener("mouseout", function (e) { var c = e.target.closest("a.cardref"); if (c && !c.contains(e.relatedTarget)) { peek = null; if (pop) pop.classList.remove("is-on"); } });
  window.addEventListener("scroll", function () { peek = null; if (pop) pop.classList.remove("is-on"); }, { passive: true });

  // unresolved @handles (posts rendered before we knew them): look the handle up, then go
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a.mention[href="/all-users"]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    var h = a.getAttribute("data-handle");
    batchGet(["displayNames/" + h]).then(function (f) {
      var d = f["displayNames/" + h], uid = d && d.fields && d.fields.userId && d.fields.userId.stringValue;
      location.href = uid ? "/profile.php?userId=" + encodeURIComponent(uid) : "/all-users";
    });
  });

  // ================================================================ composers (a post, a reply)
  function composer(form) {
    if (!form || form._wired) return;
    form._wired = true;
    var kind = form.getAttribute("data-composer");
    var ta = KD.$("[data-text]", form), send = KD.$("[data-send]", form), ring = KD.$("[data-ring]", form), slot = KD.$("[data-deck-slot]", form);
    var deck = null;
    function size() { ta.style.height = "auto"; ta.style.height = Math.min(ta.scrollHeight, 360) + "px"; }
    function paint() {
      var n = ta.value.length, left = MAX - n;
      send.disabled = !ta.value.trim() || n > MAX;
      if (!n) { ring.innerHTML = ""; return; }
      var pct = Math.min(1, n / MAX), r = 9, c = 2 * Math.PI * r;
      ring.className = "composer__ring" + (left <= 0 ? " is-over" : left <= 40 ? " is-near" : "");
      ring.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="' + r + '" class="bg"/><circle cx="12" cy="12" r="' + r + '" class="fg" stroke-dasharray="' + c.toFixed(1) + '" stroke-dashoffset="' + (c * (1 - pct)).toFixed(1) + '"/></svg>' + (left <= 40 ? "<b>" + left + "</b>" : "");
    }
    ta.addEventListener("input", function () { size(); paint(); suggest(ta); });
    ta.addEventListener("focus", function () { if (KD.signedIn) auth(); });
    ta.addEventListener("keydown", function (e) {
      if (acKeys(e)) return;
      if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && !send.disabled) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : send.click(); }
    });
    KD.$$("[data-insert]", form).forEach(function (b) {
      b.addEventListener("click", function () { insertAt(ta, b.getAttribute("data-insert")); size(); paint(); suggest(ta); });
    });
    var attach = KD.$("[data-attach-deck]", form);
    if (attach) attach.addEventListener("click", function () {
      pickDeck().then(function (d) {
        if (!d) return;
        deck = d;
        slot.innerHTML = deckHTML({ id: d.id, n: d.name, f: d.format, c: d.commander, art: d.art }) + '<button class="iconbtn iconbtn--sm composer__deckx" type="button" data-deck-remove aria-label="Remove the deck">' + icon("x") + "</button>";
        slot.hidden = false;
        KD.$("a.pdeck", slot).addEventListener("click", function (e) { e.preventDefault(); });
        KD.$("[data-deck-remove]", slot).addEventListener("click", function () { deck = null; slot.hidden = true; slot.innerHTML = ""; ta.focus(); });
        if (!ta.value.trim()) { ta.value = "My " + (d.commander ? d.commander.split(",")[0] + " " : "") + "deck: "; size(); paint(); }
        ta.focus();
      });
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var text = ta.value.trim();
      if (!text || text.length > MAX || send._busy) return;
      send._busy = true;
      send.classList.add("is-busy");
      auth().then(function (m) {
        if (!m) { askSignIn(kind === "reply" ? "reply" : "post"); return; }
        var db = firebase.firestore(), ts = firebase.firestore.FieldValue.serverTimestamp();
        if (kind === "reply") {
          return db.collection("posts").doc(data.post.i).collection("comments").add({ userId: m.uid, message: text, createdAt: ts }).then(function (ref) {
            addReply({ i: ref.id, u: m.uid, m: text, t: Date.now() });
            notify(data.post.u, m.name + " replied to your post");
            KD.ga("posts_reply");
            done();
          });
        }
        var doc = { userId: m.uid, message: text, createdAt: ts, commentsCount: 0, likes: 0, views: 0, tags: tagsOf(text), cards: cardsOf(text) };
        if (deck) doc.deck = { id: deck.id, name: deck.name, format: deck.format, commander: deck.commander, art: deck.art };
        return db.collection("posts").add(doc).then(function (ref) {
          var row = { i: ref.id, u: m.uid, m: text, t: Date.now(), l: 0, c: 0, v: 0, ty: "post" };
          if (deck) row.d = { id: deck.id, n: deck.name, f: deck.format, c: deck.commander, art: deck.art };
          rememberMine(Object.assign({ me: users[m.uid] }, row));
          if (feedEl && st.tab !== "arena") {
            var empty = KD.$(".feedempty", feedEl);
            if (empty) empty.remove();
            feedEl.insertAdjacentHTML("afterbegin", postHTML(row));
            var art = KD.$('article[data-id="' + ref.id + '"]', feedEl);
            if (art) art.classList.add("is-new");
          }
          KD.toast("Posted.", "ok");
          KD.ga("posts_post", { deck: !!deck, tags: doc.tags.length, cards: doc.cards.length });
          deck = null;
          if (slot) { slot.hidden = true; slot.innerHTML = ""; }
          done();
          if (form._sheet) form._sheet.close();
        });
      }).catch(function (err) {
        console.error("post", err);
        KD.toast(kind === "reply" ? "Couldn't post your reply. Try again." : "Couldn't publish that. Try again.", "err");
      }).then(function () { send._busy = false; send.classList.remove("is-busy"); });
      function done() { ta.value = ""; size(); paint(); }
    });
    paint();
  }
  function tagsOf(t) { var out = [], m, re = /(?:^|[^\w\/#&])#([A-Za-z][A-Za-z0-9_]{1,29})/g; while ((m = re.exec(t))) if (out.indexOf(m[1].toLowerCase()) === -1) out.push(m[1].toLowerCase()); return out.slice(0, 10); }
  function cardsOf(t) { var out = [], m, re = /\[\[([^\[\]\n]{1,60})\]\]/g; while ((m = re.exec(t))) if (out.indexOf(m[1].trim()) === -1) out.push(m[1].trim()); return out.slice(0, 10); }
  function insertAt(ta, s) {
    var a = ta.selectionStart == null ? ta.value.length : ta.selectionStart, b = ta.selectionEnd == null ? a : ta.selectionEnd;
    var pre = ta.value.slice(0, a), lead = pre && !/\s$/.test(pre) ? " " : "";
    ta.value = pre + lead + s + ta.value.slice(b);
    var pos = (pre + lead + s).length;
    ta.focus();
    ta.setSelectionRange(pos, pos);
  }

  // ---- autocomplete: @handles (displayNames), [[card names]] (Scryfall)
  var ac = { el: null, ta: null, items: [], i: 0, kind: "", token: "", timer: 0 };
  function acClose() { if (ac.el) ac.el.hidden = true; ac.items = []; ac.ta = null; }
  function acKeys(e) {
    if (!ac.el || ac.el.hidden || !ac.items.length) return false;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); ac.i = (ac.i + (e.key === "ArrowDown" ? 1 : -1) + ac.items.length) % ac.items.length; acPaint(); return true; }
    if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); acPick(ac.i); return true; }
    if (e.key === "Escape") { acClose(); return true; }
    return false;
  }
  function acPaint() {
    ac.el.innerHTML = ac.items.map(function (it, i) {
      return '<button type="button" class="acpop__it' + (i === ac.i ? " is-on" : "") + '" data-i="' + i + '">' + (ac.kind === "@" ? "@" + esc(it) : icon("mtgcard") + esc(it)) + "</button>";
    }).join("");
  }
  function acPick(i) {
    var ta = ac.ta, it = ac.items[i];
    if (!ta || it == null) return;
    var caret = ta.selectionStart, before = ta.value.slice(0, caret), after = ta.value.slice(caret);
    before = ac.kind === "@" ? before.replace(/@[A-Za-z0-9_-]*$/, "@" + it + " ") : before.replace(/\[\[[^\[\]\n]*$/, "[[" + it + "]] ");
    if (ac.kind === "[[") after = after.replace(/^\]\]/, "");
    ta.value = before + after;
    ta.focus();
    ta.setSelectionRange(before.length, before.length);
    ta.dispatchEvent(new Event("input"));
    acClose();
  }
  function suggest(ta) {
    var caret = ta.selectionStart == null ? ta.value.length : ta.selectionStart, pre = ta.value.slice(0, caret);
    var mh = pre.match(/(?:^|\s)@([A-Za-z0-9_-]{1,15})$/), mc = pre.match(/\[\[([^\[\]\n]{2,40})$/);
    if (!mh && !mc) { acClose(); return; }
    var kind = mh ? "@" : "[[", token = mh ? mh[1] : mc[1];
    clearTimeout(ac.timer);
    ac.timer = setTimeout(function () {
      (kind === "@" ? handlesLike(token) : cardsLike(token)).then(function (list) {
        var now = ta.value.slice(0, ta.selectionStart);
        if ((kind === "@" ? (now.match(/(?:^|\s)@([A-Za-z0-9_-]{1,15})$/) || [])[1] : (now.match(/\[\[([^\[\]\n]{2,40})$/) || [])[1]) !== token || !list.length) { acClose(); return; }
        if (!ac.el) {
          ac.el = document.createElement("div");
          ac.el.className = "acpop";
          ac.el.setAttribute("role", "listbox");
          document.body.appendChild(ac.el);
          ac.el.addEventListener("mousedown", function (e) { var b = e.target.closest("[data-i]"); if (b) { e.preventDefault(); acPick(+b.getAttribute("data-i")); } });
        }
        ac.ta = ta; ac.kind = kind; ac.items = list.slice(0, 7); ac.i = 0;
        acPaint();
        var r = ta.getBoundingClientRect();
        ac.el.style.left = Math.max(10, Math.min(window.innerWidth - 290, r.left + window.scrollX)) + "px";
        ac.el.style.top = (r.bottom + window.scrollY + 6) + "px";
        ac.el.hidden = false;
      });
    }, kind === "@" ? 160 : 220);
  }
  document.addEventListener("click", function (e) { if (ac.el && !ac.el.contains(e.target) && !e.target.closest("[data-text]")) acClose(); });
  function handlesLike(t) {
    var variants = [t], flip = (t.charAt(0) === t.charAt(0).toUpperCase() ? t.charAt(0).toLowerCase() : t.charAt(0).toUpperCase()) + t.slice(1);
    if (flip !== t) variants.push(flip);
    return Promise.all(variants.map(function (v) {
      var body = { structuredQuery: { from: [{ collectionId: "displayNames" }], orderBy: [{ field: { fieldPath: "__name__" } }], startAt: { values: [{ referenceValue: DB + "/displayNames/" + v }], before: true }, endAt: { values: [{ referenceValue: DB + "/displayNames/" + v + "" }], before: false }, limit: 6 } };
      return fetch(FS + ":runQuery", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (rows) { return rows.filter(function (x) { return x.document; }).map(function (x) { return x.document.name.split("/").pop(); }); })
        .catch(function () { return []; });
    })).then(function (lists) { var seen = {}, out = []; lists.forEach(function (l) { l.forEach(function (h) { if (!seen[h]) { seen[h] = 1; out.push(h); } }); }); return out; });
  }
  function cardsLike(t) {
    return KD.data.scryfall("https://api.scryfall.com/cards/autocomplete?q=" + encodeURIComponent(t), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { data: [] }; }).then(function (j) { return j.data || []; }).catch(function () { return []; });
  }

  // ---- attach one of your public decks
  function pickDeck() {
    return auth().then(function (m) {
      if (!m) { askSignIn("share your decks"); return null; }
      var body = { structuredQuery: { from: [{ collectionId: "publicDecks" }], where: { fieldFilter: { field: { fieldPath: "publisherId" }, op: "EQUAL", value: { stringValue: m.uid } } }, select: { fields: ["name", "format", "_commander", "headerImage", "updatedAt", "createdAt"].map(function (f) { return { fieldPath: f }; }) }, limit: 100 } };
      return fetch(FS + ":runQuery", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.ok ? r.json() : []; }).then(function (rows) {
        var decks = rows.filter(function (x) { return x.document; }).map(function (x) {
          var f = x.document.fields || {}, cmd = f._commander && f._commander.mapValue && f._commander.mapValue.fields || {};
          var sv = function (v) { return v && (v.stringValue || v.timestampValue) || ""; };
          var art = sv(cmd.imageUrl) || sv(f.headerImage);
          return { id: x.document.name.split("/").pop(), name: sv(f.name) || "Untitled deck", format: String(sv(f.format)).toLowerCase().indexOf("commander") !== -1 ? "commander" : String(sv(f.format)).toLowerCase().replace(/[^a-z0-9]/g, ""), commander: sv(cmd.name), art: KD.data && KD.data.artUrl ? KD.data.artUrl(art) : art, t: sv(f.updatedAt) || sv(f.createdAt) };
        }).filter(function (d) { return /^https:\/\/cards\.scryfall\.io\//.test(d.art) || !d.art; }).sort(function (a, b) { return a.t < b.t ? 1 : -1; });
        return new Promise(function (resolve) {
          var s = KD.sheet({
            title: "Attach a deck",
            sub: decks.length ? "One of your public decks, shown as a card in your post." : "",
            body: decks.length ? '<div class="deckpick">' + decks.map(function (d, i) {
              return '<button type="button" class="deckpick__it" data-i="' + i + '"><span class="deckpick__art"' + (d.art ? ' style="background-image:url(&quot;' + esc(d.art) + '&quot;)"' : "") + '></span><span><b>' + esc(d.name) + "</b><small>" + esc(fmtLabel(d.format)) + (d.commander ? " · " + esc(d.commander) : "") + "</small></span></button>";
            }).join("") + "</div>" : '<div class="empty">' + icon("layers") + "<h3>No public decks yet</h3><p>Publish a deck from your dashboard and it shows up here.</p><a class=\"btn btn--ghost\" href=\"/dashboard\">Open the dashboard</a></div>",
            onClose: function (v) { resolve(v && v.id ? v : null); }
          });
          KD.$$("[data-i]", s.el).forEach(function (b) { b.addEventListener("click", function () { s.close(decks[+b.getAttribute("data-i")]); }); });
        });
      });
    });
  }

  KD.$$("form[data-composer]").forEach(composer);

  // phones: the pen button opens the composer in a sheet
  var fab = KD.$("[data-fab]");
  if (fab) fab.addEventListener("click", function () {
    var form = KD.$('form[data-composer="post"]') || KD.$('form[data-composer="reply"]');
    if (!form) return;
    if (!KD.mobile()) { form.scrollIntoView({ block: "center", behavior: KD.reduce ? "auto" : "smooth" }); KD.$("[data-text]", form).focus(); return; }
    var home = form.parentNode, next = form.nextSibling;
    var s = KD.sheet({ title: form.getAttribute("data-composer") === "reply" ? "Reply" : "New post", body: "", onClose: function () { form._sheet = null; home.insertBefore(form, next); } });
    s.body.appendChild(form);
    form._sheet = s;
    var ta = KD.$("[data-text]", form);
    try { ta.focus({ preventScroll: true }); } catch (e) { /* ignore */ } // still inside the tap, so phones raise the keyboard
    setTimeout(function () { if (document.activeElement !== ta) ta.focus(); }, 60);
  });

  // ================================================================ a post's own page
  if (isPostPage) {
    var post = data.post, repliesEl = KD.$("section[data-replies]");
    var countEl = KD.$(".postmeta [data-reply-count]");
    addReplyRef = function (r) {
      var none = KD.$("[data-noreplies]", repliesEl);
      if (none) none.remove();
      repliesEl.insertAdjacentHTML("beforeend", replyHTML(r));
      var el = repliesEl.lastElementChild;
      if (el) { el.classList.add("is-new"); el.scrollIntoView({ block: "nearest", behavior: KD.reduce ? "auto" : "smooth" }); }
      bump(1);
    };
    var bump = function (d) {
      var n = Math.max(0, (parseInt(countEl.textContent.replace(/\D/g, ""), 10) || 0) + d);
      stat("[data-reply-count]", n, "reply", "replies");
      KD.$$("article.post--full .pact--reply span").forEach(function (s) { s.textContent = n || ""; });
    };
    deleteReplyRef = function (cid, el) {
      KD.confirm({ title: "Delete this reply?", confirm: "Delete", danger: true }).then(function (ok) {
        if (!ok) return;
        auth().then(function (m) {
          if (!m) return askSignIn("delete replies");
          return firebase.firestore().collection("posts").doc(post.i).collection("comments").doc(cid).delete().then(function () { el.remove(); bump(-1); KD.toast("Reply deleted.", "ok"); });
        }).catch(function (err) { console.error("delete reply", err); KD.toast("Couldn't delete that reply. Try again.", "err"); });
      });
    };
    // a view, once per visit
    (function () {
      var key = "kd_post_viewed_" + post.i;
      try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch (e) { /* count anyway */ }
      fetch(FN + "incrementPostViews", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ data: { postId: post.i } }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var n = j && j.result && j.result.newViewCount;
          if (!n) return;
          KD.$$("article.post--full [data-views]").forEach(function (v) { v.textContent = n; });
          stat("[data-views]", n, "view", "views");
        }).catch(function () { /* the count just doesn't move */ });
    })();
    // an old cached copy of this page: fetch the post's current counts and replies
    if (stale()) {
      getJSON("/posts-feed.php?id=" + encodeURIComponent(post.i) + "&replies=1").then(function (res) {
        merge(res);
        if (res.post) {
          KD.$$("article.post--full [data-likes]").forEach(function (el) { el.textContent = res.post.l || ""; });
          stat("[data-likes]", res.post.l, "like", "likes");
        }
        if (res.replies) {
          var n = res.replies.length;
          repliesEl.innerHTML = n ? res.replies.map(replyHTML).join("") : '<p class="hint replies__note" data-noreplies>No replies yet. Start the conversation.</p>';
          stat("[data-reply-count]", n, "reply", "replies");
          KD.$$("article.post--full .pact--reply span").forEach(function (s) { s.textContent = n || ""; });
        }
      }).catch(function () { /* the older copy stays */ });
    }
    // local time for the timestamp line
    var tm = KD.$(".postmeta time");
    if (tm) { var d = new Date(Date.parse(tm.getAttribute("datetime"))); tm.textContent = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }) + " · " + d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); }
    if (location.hash === "#reply") {
      var rt = KD.$("#reply-text");
      if (rt && KD.signedIn) setTimeout(function () { rt.focus(); }, 200);
    }
  }
})();
